import { Component, OnInit, inject } from '@angular/core'
import { Router } from '@angular/router'
import { Observable } from 'rxjs'
import { AppointmentService } from 'src/app/core/services/appointment/appointment.service'
import { CustomerService } from 'src/app/core/services/customer.service'
import { StatisticsService } from 'src/app/core/services/statistics.service'
import { PaginatedList } from 'src/app/shared/interfaces/api-response/api-paginated-list.interface'
import { AppointmentFilter } from 'src/app/shared/interfaces/appointment/appointment-filter.interface'
import { AppointmentListItem } from 'src/app/shared/interfaces/appointment/appointment-list-item.interface'
import { CustomerFilter } from 'src/app/shared/interfaces/customer/customer-filter.interface'
import { CustomerListItem } from 'src/app/shared/interfaces/customer/customer-list-item.interface'
import { StatCounter } from 'src/app/shared/interfaces/statistics/stat-counter.interface'
import { BasicStatItem } from 'src/app/shared/interfaces/statistics/stat-basic-item.interface'
import { StatGroupCounter } from 'src/app/shared/interfaces/statistics/stat-group-counter.interface'
import { DashboardHomeService } from 'src/app/core/dashboard/dashboard-home.service'
import { DashboardHome } from 'src/app/shared/interfaces/dashboard/dashboard-home.interface'
import { AsyncPipe } from '@angular/common'
import { SparklineAreaChartComponent } from 'src/app/shared/components/statistics/sparkline-area-chart/sparkline-area-chart.component'
import { SparklinePieChartComponent } from 'src/app/shared/components/statistics/sparkline-pie-chart/sparkline-pie-chart.component'
import { SimpleStatBoxComponent } from 'src/app/shared/components/statistics/simple-stat-box/simple-stat-box.component'
import { CUSTOMER_SORT_OPTIONS } from 'src/app/shared/interfaces/customer/customer-sort-types'

@Component({
    selector: 'sf-dashboard-home',
    imports: [SimpleStatBoxComponent, SparklineAreaChartComponent, SparklinePieChartComponent, AsyncPipe],
    templateUrl: './dashboard-home.component.html',
    styleUrls: ['./dashboard-home.component.scss'],
})
export class DashboardHomeComponent implements OnInit {
    private dashboardHomeService = inject(DashboardHomeService)

    customers$!: Observable<PaginatedList<CustomerListItem> | null>
    customerFilter: CustomerFilter = {
        sort: { sortBy: CUSTOMER_SORT_OPTIONS[0].value, sortDirection: 'D' },
        pageNumber: 1,
        pageSize: 5,
    }

    appointments$!: Observable<PaginatedList<AppointmentListItem> | null>

    // get date for today starting at 00:00:00
    today = new Date()
    startOfDay = new Date(this.today.getFullYear(), this.today.getMonth(), this.today.getDate(), 0, 0, 0).toISOString()
    endOfDay = new Date(this.today.getFullYear(), this.today.getMonth(), this.today.getDate(), 23, 59, 59).toISOString()

    appointmentFilter: AppointmentFilter = {
        pageNumber: 1,
        pageSize: 5,
        from: this.startOfDay,
        to: this.endOfDay,
    }

    baseStats$!: Observable<BasicStatItem[]>
    customerChartData$!: Observable<StatCounter[]>
    customerMarketSourceChartData$!: Observable<StatGroupCounter[]>
    appointmentChartData$!: Observable<StatCounter[]>

    dashboardStats$!: Observable<DashboardHome>

    constructor(
        private customerService: CustomerService,
        private appointmentService: AppointmentService,
        private statService: StatisticsService,
        private router: Router
    ) {}

    ngOnInit(): void {
        this.dashboardStats$ = this.dashboardHomeService.getDashboardHome()

        this.baseStats$ = this.statService.getBaseStatistics()
        this.customers$ = this.customerService.getCustomersPaged(this.customerFilter)
        this.appointments$ = this.appointmentService.getAppointmentsPaged(this.appointmentFilter)
        this.customerChartData$ = this.statService.getCustomerStatistics()
        this.customerMarketSourceChartData$ = this.statService.getCustomerByMarketSources()
        this.appointmentChartData$ = this.statService.getAppointmentStatistics()
    }

    customerPageChanged(pageNumber: number): void {
        this.customerFilter.pageNumber = pageNumber
        this.customers$ = this.customerService.getCustomersPaged(this.customerFilter)
    }

    appointmentPageChanged(pageNumber: number): void {
        this.appointmentFilter.pageNumber = pageNumber
        this.appointments$ = this.appointmentService.getAppointmentsPaged(this.appointmentFilter)
    }
}
